var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from '../baseService';
export class SurveysService extends BaseService {
    constructor(props) {
        super(props);
    }
    startSurvey(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { survey, token } } = yield this.api.fetchOpenApi('surveys', 'post', params, {}, 'forms');
            return { survey, token };
        });
    }
    loadSurvey(survey_id, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data: { survey, branches: branches_url, content: content_url } } = yield this.api.fetchOpenApi(`surveys/${survey_id}/with-branches/urls`, 'get', {}, Object.assign({}, (token
                ? { headers: { Authorization: `Bearer ${token}` } }
                : {})), 'forms');
            const [branchesRes, contentRes] = yield Promise.all([fetch(branches_url), fetch(content_url)]);
            const [branches, content] = yield Promise.all([
                branchesRes.json(),
                contentRes.json(),
            ]);
            return { survey, branches, content };
        });
    }
    sendAnswers(surveyId, params, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`surveys/${surveyId}/answers`, 'post', params, Object.assign({}, (token
                ? { headers: { Authorization: `Bearer ${token}` } }
                : {})), 'forms');
            return data;
        });
    }
    rollback(surveyId, stepId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield this.api.fetchOpenApi(`surveys/${surveyId}/answers/${stepId}`, 'delete', {}, {}, 'forms');
            return data;
        });
    }
    submit(surveyId, patientId, token) {
        return __awaiter(this, void 0, void 0, function* () {
            if (token) {
                yield this.api.fetchOpenApi(`surveys/${surveyId}/bind`, 'post', { anonymous_token: token }, {}, 'forms');
            }
            const { data } = yield this.api.fetchOpenApi(`surveys/${surveyId}/submit`, 'post', { params: { patient_id: patientId } }, {}, 'forms');
            return { survey: data };
        });
    }
}
